import { render, staticRenderFns } from "./PostnameRules.vue?vue&type=template&id=7669a3de&scoped=true&"
import script from "./PostnameRules.vue?vue&type=script&lang=js&"
export * from "./PostnameRules.vue?vue&type=script&lang=js&"
import style0 from "./PostnameRules.vue?vue&type=style&index=0&id=7669a3de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7669a3de",
  null
  
)

export default component.exports